export default {
  selectedOdorParamterCode: '',
  odorOtherText: '',
  showLabel: false,
  showOtherTextbox: false,
};
